<div class="toolbar">
  <app-container-standard title="Order Report">
    <div class="filters-bar">
      <mat-form-field class="filter-field">
        <mat-label>Order Number</mat-label>
        <input type="text" matInput [ngModel]="orderNumberSearch" (ngModelChange)="onOrderNumberInput($event)"
               (keyup.enter)="applyOrderNumberSearch()" [maxlength]="ORDER_NUMBER_MAX_LENGTH" inputmode="numeric"
               [pattern]="orderNumberPattern" [errorStateMatcher]="orderNumberErrorMatcher"
               placeholder="Press Enter to find">
        <mat-icon *ngIf="orderNumberSearch" matSuffix (click)="$event.stopPropagation(); clearOrderNumberSearch()" class="clear-icon">close</mat-icon>
        <mat-error>Must be {{ ORDER_NUMBER_MIN_LENGTH }}–{{ ORDER_NUMBER_MAX_LENGTH }} digits.</mat-error>
      </mat-form-field>

      <button (click)="applyOrderNumberSearch()" class="theme-primary white-text search-button" mat-flat-button
              title="Find order by exact order number">
        <mat-icon>search</mat-icon> Find
      </button>

      <mat-form-field class="filter-field filter-field--narrow">
        <mat-label>Card (last 4)</mat-label>
        <input type="text" matInput [ngModel]="cardSearch" (ngModelChange)="onCardInput($event)"
               (keyup.enter)="applyCardSearch()" maxlength="4" inputmode="numeric" placeholder="1234">
        <mat-icon *ngIf="cardSearch" matSuffix (click)="$event.stopPropagation(); clearOrderNumberSearch()" class="clear-icon">close</mat-icon>
      </mat-form-field>

      <button (click)="applyCardSearch()" class="theme-primary white-text search-button" mat-flat-button
              title="Orders paid with a card ending in these digits, within the Time period and System below if set">
        <mat-icon>credit_card</mat-icon> Find card
      </button>
    </div>

    <div class="order-number-banner" *ngIf="orderNumberSearch">
      <mat-icon>info</mat-icon>
      <span>System, Time period and Max orders are disabled while order number is set.</span>
    </div>

    <div class="order-number-banner" *ngIf="cardSearchLabel">
      <mat-icon>credit_card</mat-icon>
      <span>{{ cardSearchLabel }}. Card search covers Stripe payments (web and tablet); Vipps and credit have no card.</span>
      <mat-icon class="clear-icon" (click)="clearOrderNumberSearch()" title="Back to the normal list">close</mat-icon>
    </div>

    <div class="filters-bar filters-bar--date">
      <mat-form-field class="filter-field">
        <mat-label>System</mat-label>
        <input type="text" matInput [value]="selectedSystem$.value" placeholder="All"
               [disabled]="!!orderNumberSearch"
               (keyup)="filterSystemOptions($event.target['value'])" [matAutocomplete]="autoSystem">
        <mat-autocomplete #autoSystem="matAutocomplete">
          <mat-option (click)="setSystemFilter('')">
            <span>All</span>
          </mat-option>
          <mat-option *ngFor="let system of filteredSystemOptions$ | async" (click)="setSystemFilter(system)" [value]="system">
            <span>{{ system }}</span>
          </mat-option>
        </mat-autocomplete>
        <mat-icon *ngIf="selectedSystem$.value" matSuffix (click)="$event.stopPropagation(); clearSystemFilter()" class="clear-icon">close</mat-icon>
      </mat-form-field>

      <mat-form-field class="filter-field">
        <mat-label>Time period</mat-label>
        <mat-select placeholder="Latest" [(value)]="timeSelected" [disabled]="!!orderNumberSearch" (selectionChange)="setTimePeriodeEvent($event)">
          <mat-option value="TODAY">Today</mat-option>
          <mat-option value="YESTERDAY">Yesterday</mat-option>
          <mat-option value="THIS_WEEK">This week</mat-option>
          <mat-option value="THIS_MONTH">This month</mat-option>
          <mat-option value="LAST_MONTH">Last month</mat-option>
          <mat-option value="CUSTOM">Customized</mat-option>
        </mat-select>
        <mat-icon *ngIf="timeSelected" matSuffix (click)="$event.stopPropagation(); clearTimeFilter()" class="clear-icon">close</mat-icon>
      </mat-form-field>

      <mat-form-field *ngIf="timeSelected == 'CUSTOM'" class="filter-field filter-field--range">
        <mat-label>Custom Date Range</mat-label>
        <mat-date-range-input [rangePicker]="picker" [disabled]="!!orderNumberSearch">
          <input matStartDate placeholder="Start date" (dateChange)="setCustomRange($event, 'start')">
          <input matEndDate placeholder="End date" (dateChange)="setCustomRange($event, 'end')">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <mat-form-field class="filter-field filter-field--narrow">
        <mat-label>Max orders</mat-label>
        <mat-select [(value)]="maxOrders" [disabled]="!!orderNumberSearch">
          <mat-option *ngFor="let option of maxOrdersOptions" [value]="option">{{ option }}</mat-option>
        </mat-select>
      </mat-form-field>

      <button (click)="onSubmit()" class="theme-primary white-text search-button" mat-flat-button
              [disabled]="!!orderNumberSearch"
              title="Load orders for the selected time period">
        <mat-icon>search</mat-icon> Search
      </button>
    </div>
  </app-container-standard>
</div>

<app-table-standard-layout [dataSource$]="companies$" [title]="'Orders'" [rowActionButtons]="rowActionButtons"
  [columnSettings]="columnSettings" [searchFields]="searchFields" [forceLoading]="isLoading">
</app-table-standard-layout>
